












import { defineComponent, useRouter } from '@nuxtjs/composition-api'

// Common
import { getTextExcerpt } from '@/common/utils/characters'

// Composable
import useKnowledgeBase from '@/composables/learn-and-support/useKnowledgeBase'
import useKnowledgebaseAnalytics from '~/composables/analytics/useKnowledgebaseAnalytics'

// Types
import { SupportArticleInterface } from '@/types/support/knowledgeBaseTypes'
import useSearchAnalytics from '~/composables/analytics/useSearchAnalytics'
import { useKnowledgeBaseStore } from '~/store/knowledge-base'

export default defineComponent({
  name: 'SupportArticleRow',
  props: {
    supportArticleData: {
      type: Object as () => SupportArticleInterface,
      required: true,
    },
    position: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const knowledgeBaseStore = useKnowledgeBaseStore()
    const { getSupportArticleLink } = useKnowledgeBase()
    const { trackKnowledgebaseArticleClick } = useKnowledgebaseAnalytics()
    const { trackSiteSearchEngagement } = useSearchAnalytics()
    const router = useRouter()

    // On a click, send analytics and chnage window location
    const onArticleClick = (articleNumber: string, urlname: string) => {
      trackSiteSearchEngagement({
        pages_number: knowledgeBaseStore.page?.currentPage,
        query_executed: knowledgeBaseStore.searchInput,
        results_per_page: knowledgeBaseStore.page.resultsPerPage,
        view_item_list_id: 'KBRP',
        view_item_list_name: 'Knowledge Base Result Page',
        selected_item_list_name: 'Knowledge Base Result Page (KBRP)',
        selected_result_destination: getSupportArticleLink(articleNumber, urlname),
        selected_result_text: props.supportArticleData.title.raw,
        filters: undefined,
        selected_item_index: props.position,
      })

      trackKnowledgebaseArticleClick({
        type: 'articles',
        clickedArticleTitle: props.supportArticleData.title.raw,
        clickedArticlePosition: props.position,
      })

      router.push(getSupportArticleLink(articleNumber, urlname))
    }

    return {
      onArticleClick,
      getTextExcerpt,
    }
  },
})
